import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../../../components/TextInputs";
import { APP_ICONS } from "../../../../assets";
import { setBlogSubscriberEmail } from "../../../../lib/slices/searchKeysSlice";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const BlogSubscribersFilters = () => {
    // Dispatch Hook
    const dispatch = useDispatch();
    // Translation Hook
    const { t } = useTranslation(["common"]);
    // Selector Hook
    const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

    return (
        <Stack p={2} bgcolor={"primary.light"}>
            <TextInput
                InputStartIcon={<img src={APP_ICONS.searchGreyIcon} width={25} />}
                InputEndIcon={
                    searchKeys.blogSubscriberEmail && (
                        <CancelOutlinedIcon
                            fontSize="small"
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                dispatch(
                                    setBlogSubscriberEmail("")
                                );
                            }}
                        />
                    )
                }
                placeholder={t("searchByEmail", { ns: "common" })}
                value={searchKeys.blogSubscriberEmail}
                onChange={(e) => {
                    dispatch(
                        setBlogSubscriberEmail(e.target.value)
                    );
                }}
            />

        </Stack>
    )
}

export default BlogSubscribersFilters;